import { FinanceInvoices } from "@widgets/FinanceInvoices";
import { Tabs } from "antd";
import { Lock, Mail, Shield } from "lucide-react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { PaymentsTab } from "./ui/PaymentsTab";
import { PurchasesTab } from "./ui/PurchasesTab";

type FinanceTab = "invoices" | "purchases" | "payments";

const admins = [
  { id: 1, name: "Shivam Arora", role: "Owner", email: "shivam@cloutflow.com" },
  // {
  //   id: 2,
  //   name: "Sarah Smith",
  //   role: "System Admin",
  //   email: "sarah@cloutflow.com",
  // },
];

export function FinancePage() {
  const [searchParams, setSearchParams] = useSearchParams({
    tab: "invoices",
  });
  const activeTab = searchParams.get("tab") as FinanceTab;
  const [hasAccess, setHasAccess] = useState(true);

  const tabItems = [
    {
      key: "invoices",
      label: "Billing",
      children: (
        <div className={styles.tabContent}>
          <FinanceInvoices />
        </div>
      ),
    },
    {
      key: "purchases",
      label: "Purchases",
      children: (
        <div className={styles.tabContent}>
          <PurchasesTab />
        </div>
      ),
    },
    {
      key: "payments",
      label: "Payments",
      children: (
        <div className={styles.tabContent}>
          <PaymentsTab />
        </div>
      ),
    },
    // {
    //   key: "billing",
    //   label: "Billing Details",
    //   children: (
    //     <div className={styles.tabContent}>Billing Details content</div>
    //   ),
    // },
  ];

  if (!hasAccess) {
    return (
      <div
        className={styles.accessRestricted}
        onDoubleClick={() => setHasAccess(true)}
      >
        <div className={styles.restrictedContent}>
          <div className={styles.lockIcon}>
            <Lock size={32} className={styles.lockIconSvg} />
          </div>
          <h1 className={styles.restrictedTitle}>Access Restricted</h1>
          <p className={styles.restrictedDescription}>
            You don&apos;t have permission to access the{" "}
            <span className={styles.restrictedHighlight}>Finance</span> module.
            Please contact your system administrator to request access.
          </p>

          <div className={styles.adminsCard}>
            <div className={styles.adminsCardHeader}>
              <Shield size={14} className={styles.shieldIcon} />
              <span className={styles.adminsCardTitle}>
                Organization Admins
              </span>
            </div>
            <div className={styles.adminsList}>
              {admins.map((admin) => (
                <div key={admin.id} className={styles.adminItem}>
                  <div className={styles.adminInfo}>
                    <div className={styles.adminAvatar}>
                      {admin.name.charAt(0)}
                    </div>
                    <div>
                      <div className={styles.adminName}>{admin.name}</div>
                      <div className={styles.adminRole}>{admin.role}</div>
                    </div>
                  </div>
                  <a
                    href={`mailto:${admin.email}`}
                    className={styles.adminEmailLink}
                    title={`Email ${admin.name}`}
                  >
                    <Mail size={16} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.container}
      // onDoubleClick={() => setHasAccess(false)}
      // title="Double click to simulate no-access state"
    >
      <div className={styles.header}>
        <h1 className={styles.title}>Finance</h1>
        {/* <p className={styles.subtitle}>
          Manage invoices, billing details, and purchases.
        </p> */}
      </div>

      <Tabs
        activeKey={activeTab}
        items={tabItems}
        destroyInactiveTabPane
        onChange={(key) => {
          const params = new URLSearchParams();
          params.set("tab", key);
          setSearchParams(params);
        }}
        className={styles.tabs}
        tabBarStyle={{ marginBottom: 0 }}
      />
    </div>
  );
}
